/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-11-10 10:45:00
 */

 import {IconBtnItem} from "src/components/iconBtnGroup/iconBtnGroup";
 import {ColDefCustom, default as AgGridVueCustomTsx} from "src/components/agGridCustom/agGridVueCustomTsx";
 import _ from 'lodash'
 import ListPageService from 'src/types/ListPage';
 import override from "src/dectorators/override";
 import {QueryFormVOI} from "src/components/queryForm/queryForm";
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import ErrorFile from './errorFile';
 import TestApi, {TestDOI} from '../api/testApi';
 import {default as CellOperate} from "../../../../components/agGridComponent/cellOperate";
 import alertErroeFileAddModel from './erroeFileAddModel';
 import FileUtil from 'src/util/fileUtil';
 import { Toast } from 'src/util/toast';


export default class ErrorFileService extends ListPageService {
    ctx: ErrorFile;

	constructor (ctx: ErrorFile) {
	    super()
		this.ctx = ctx
	}

    @override
	createColumns (): ColDefCustom [] {
        let t = this;
		return [
            {
                headerName: '名称',
                field: 'file_name',
                minWidth: 160
            },
            {
                headerName: '上传人',
                field: 'operator',
                minWidth: 160
            },
            {
                headerName: '上传时间',
                field: 'upload_datetime',
                minWidth: 160
            },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 200,
                maxWidth: 200,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                       text: '下载',
                       click: t.download.bind(t),
                    },
                    {
                        text: '查看',
                        click: t.preview.bind(t),
                    },
                    {
                       text: '删除',
                       async click(params) {
                           let res = await Toast.confirm();
                           if (!res) {
                               return;
                           }
                           let data: TestDOI.ErrorNoDetails = params.data;
                           await t.delete(data.id);
                       },
                   },
                ]
            },
        ]
	}

    @override
	createBtnGroup (): Array<IconBtnItem> {
		let t = this;
         return [
            {
                text: '新增',
                async onClick() {
                     let res = await alertErroeFileAddModel(t.ctx.id);
                     if (res) {
                        t.searchTable();
                     }
                },
            },
         ];
	}
    
    async preview(params) {
        debugger
        let list: Array<any> = params.data.file_url.split(",");
        list.forEach(url => {
            if(url !=""){
                FileUtil.urlPreviewFile(url);
            }
        });
    }

    async download(params) {
        let list: Array<any> = params.data.file_url.split(",");
        list.forEach(url => {
            if(url !=""){
                FileUtil.urlDownloadFile(url, params.data.file_name);
            }
        });
    }

    async delete(id: number) {
        let { code } = await TestApi.delete_error_file({ id: id });
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    @override
    async searchTable () {
         let ctx = this.ctx
         let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
         ag.showLoading()
         let {code, data} = await TestApi.id_by_details({
             ...ctx.searchParams,
             page_size: ctx.pageSize,
			 page_index: ctx.currentPage
         })
         ag.hideLoading()
 
         if (code === 0) {
             ctx.rowData = data.data_info || [];
             ctx.total = data.page_count;
         }
    }

     @override
	initSearchParams (): void {
		this.ctx.searchParams = {
            ...this.ctx.queryForm.getQueryObj<TestDOI.QueryRowDataParamsIDetail>(),
            id: this.ctx.id,
            page_index: this.ctx.currentPage,
            page_size: this.ctx.pageSize,
        }
		this.ctx.currentPage = 1
	}

    @override
	async searchTable () {
		let ctx = this.ctx
		let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
		ag.showLoading()
        let {code, data} = await TestApi.id_by_details({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage
        })
		ag.hideLoading()

		if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count
		}
    }

}